import { render, staticRenderFns } from "./BRyCloud.vue?vue&type=template&id=4aaefe4b&scoped=true&"
import script from "./BRyCloud.vue?vue&type=script&lang=js&"
export * from "./BRyCloud.vue?vue&type=script&lang=js&"
import style0 from "./BRyCloud.vue?vue&type=style&index=0&id=4aaefe4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaefe4b",
  null
  
)

export default component.exports